
<li class="learning-list-li">
  <div class="list-box">
      <div class="flip-container" id="{{LearningCardAll['CourseID']+'-'+LearningCardAll['ILTID']}}">
          <div class="flip-container">
              <div class="flipper">
                  <div class="front">

                      <div class="front-inner" [ngSwitch]="LearningCardAll['Image'].substring(LearningCardAll['Image'].lastIndexOf('/')+1, LearningCardAll['Image'].length)">

                          <!-- (click)="flip(LearningCardAll['CourseID']+'-'+LearningCardAll['ILTID'])" -->

<li class="learning-list-li">
      <figure class="course">
              <img *ngSwitchCase="'ILT.jpg'" class="responsiveImage" src="assets/img/ILT.jpg" alt="Image">
              <img *ngSwitchCase="'ebook.jpg'" class="responsiveImage" src="assets/img/ebook.jpg" alt="Image">
              <img *ngSwitchCase="'Elearning.jpg'" class="responsiveImage" src="assets/img/Elearning.jpg" alt="Image">
              <img *ngSwitchDefault class="responsiveImage" src="{{LearningCardAll['Image']}}" alt="Image">
              <!-- <img src="http://182.156.251.238/Wiz7QC_SE/WCR/WCRCourseLaunchFolderImages/41/retail10.jpg" /> -->
             
                <div >
                    <a href="javascript:void(0);" class="star-label" (click)="openCatalogDetail(LearningCardAll,'Rating')">
                        <span class="fa fa-star"></span>{{LearningCardAll['CourseRating']}}
                    </a></div>
                   <div *ngIf="LearningCardAll['GamificationPoints']>0" >
                    <a href="javascript:void(0);" class="winstar-label ui-link" (click)="showGamificationRule(ItemDetail['CourseID'])">
                        <span class="star-icon"></span>{{LearningCardAll['GamificationPoints']}}
                    </a></div>
          
                  <div class="progress-bar-main">
                          <div class="progress-bar-inn" [style.width]="LearningCardAll['Progress']+'%'"></div>
                      </div>
              <div class="stats-container">
                  <div class="course_name">{{LearningCardAll['Name']}}</div>
                  <span>{{LearningCardAll['TypeName']}}</span>
                  <!-- <span [ngClass]="{'opted-type':LearningCardAll['LearningFlag']=='Opted','assigned-type':LearningCardAll['LearningFlag']=='Assigned'}">{{LearningCardAll['LearningFlag']}}</span> -->
              </div>
             
              <div class="hover">
                  <!-- <div class="title-content">
                      <span>{{LearningCardAll['Name']}}</span>
                  </div> -->
                  <div class="title-content hand-cursor" (click)="openCatalogDetail(LearningCardAll,false)">
                    <span [innerHtml]="bs.textLimit(LearningCardAll['Name'],22)"></span>
                    <span class="tooltip-text" style="word-break: break-word;" *ngIf="LearningCardAll['Name'].length>22" [innerHtml]="LearningCardAll['Name']"></span>
                    <div>
                        <span [innerHtml]="bs.textLimit(LearningCardAll['Topic'],22)"></span>
                        <span class="tooltip-text" style="word-break: break-word;" *ngIf="LearningCardAll['Topic'].length>22" [innerHtml]="LearningCardAll['Topic']"></span>
                    </div>
                </div>
                  <div class="info hand-cursor" (click)="openCatalogDetail(LearningCardAll,false)">
                      <div class="one-third b-right">
                          <div class="stat"><span>Credit Hrs</span> {{LearningCardAll['CreditHours']}}</div>
                      </div>
                      <div class="one-third">
                          <div class="stat"><span>Expiry Date</span> {{LearningCardAll['ExpiryDay']}}  {{LearningCardAll['ExpiryYear']}}</div>
                      </div>
                      <div class="progress-status">
                              {{LearningCardAll['Status'] +' | '+ LearningCardAll['Progress'] +'%' }}
                          </div>
                  </div>
                
                  <div class="icons" >                     
                      <div class="select action-icon tooltips hand-cursor" (click)="openCatalogDetail(LearningCardAll,true)">
                        <i class="fa"  ></i>
                        <span class="tooltiptext">Detail</span>
                      </div>                        
                  </div>
              </div>
              <a href="#"></a>
          </figure>
</li>
</div>
</div>

</div>
</div>
</div>
<div id="divGmfctnRlFrCtlg{{ItemDetail['CourseID']}}" class="hideDiv">
    <app-gamification-rule *ngIf="loadGamificationRule(ItemDetail['CourseID'])" [learningItem]="ItemDetail"></app-gamification-rule>
</div>
</div>
</li>

